import create from 'zustand';
import { disconnectCalendar, fetchSyncDataForSpace, resyncCalendar } from '../../../../../api/calendarSync';
import { SyncStatus } from '../../connect-calendar/util/syncStatus';
import { ResyncErrorSubject$ } from '../../connect-calendar/components/ConnectCalendarCTA';
import { DisconnectCalEventSubject$ } from '../../connect-calendar/components/DisconnectCalDialog';

const useCalendarStore = create((set, get) => ({
  selectedSpaceId: '',
  spaces: [],
  listingsBySpaceId: {},
  syncStatus: null,
  syncedCalendarData: null,
  isDisconnectingCal: false,
  setSyncStatus: (status) => set({ syncStatus: status }),
  setSyncedCalendarData: (data) => set({ syncedCalendarData: data }),
  setSelectedSpaceId: (id) => set({ selectedSpaceId: id }),
  setSpaces: (spaces) => set({ spaces }),
  setListingsBySpaceId: (listingsBySpaceId) => set({ listingsBySpaceId }),
  setConnectSpace: (spaceId) => set({ selectedSpaceId: spaceId, syncStatus: SyncStatus.SYNCING }),
  fetchSyncData: async () => {
    const { selectedSpaceId } = get();
    const { data, error } = await fetchSyncDataForSpace(selectedSpaceId);
    if (error) {
      return;
    }

    const { obj_state: status = '', ...syncedCalendarData } = data;
    set({ syncStatus: status, syncedCalendarData });
  },
  resyncCalendar: async () => {
    const { selectedSpaceId } = get();
    const { error } = await resyncCalendar(selectedSpaceId);
    if (error) {
      ResyncErrorSubject$.next(null);
      return;
    }

    set({ syncStatus: SyncStatus.SYNCING });
  },
  disconnectSyncedCalendar: async () => {
    set({ isDisconnectingCal: true });
    const { selectedSpaceId } = get();
    const { error } = await disconnectCalendar(selectedSpaceId);
    if (error) {
      DisconnectCalEventSubject$.next({ type: 'error' });
      set({ isDisconnectingCal: false });
      return;
    }

    DisconnectCalEventSubject$.next({ type: 'success' });
  }
}));

export default useCalendarStore;
